module.exports = __webpack_public_path__ + "/images/ico-check-grey.d5e3d4f.svg";